import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hourMinute'
})
export class HourMinutePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;
    
    // Split the time string by ":"
    const timeParts = value.split(":");

    // Extract the hour and minute parts
    const hour = timeParts[0];
    
    const minute = timeParts[1];
    // Reconstruct the time string without the seconds part
    return `${hour}:${minute}`;
  }

}
